import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { listEvents } from "../Redux/Actions/eventActions";
import Loading from "../components/LoadingError/Loading";
import Message from "../components/LoadingError/Error";
import Header from "../components/Header";
// import Footer from "../components/Footer";

const EventsScreen = () => {
  const dispatch = useDispatch();

  const eventList = useSelector((state) => state.eventList);
  const { loading, error, events } = eventList;

  const [filter, setFilter] = useState("all");

  useEffect(() => {
    dispatch(listEvents());
  }, [dispatch]);

  const isEventPast = (eventDate) => {
    const today = new Date();
    const date = new Date(eventDate);
    return date < today;
  };

  const isEventToday = (eventDate) => {
    const today = new Date();
    const date = new Date(eventDate);
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const filteredEvents =
    filter === "all"
      ? events
      : filter === "upcoming"
      ? events.filter((event) => !isEventPast(event.date))
      : events.filter((event) => isEventPast(event.date));

  // Modified sorting function to show upcoming events first (closest first),
  // then today's events, and past events last (most recent past events first)
  const sortedEvents = [...filteredEvents].sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    const isPastA = isEventPast(a.date);
    const isPastB = isEventPast(b.date);
    const isTodayA = isEventToday(a.date);
    const isTodayB = isEventToday(b.date);
    
    // If one is past and the other isn't, the upcoming one comes first
    if (isPastA && !isPastB) return 1;
    if (!isPastA && isPastB) return -1;
    
    // If both are past or both are upcoming, sort by date
    if (isPastA && isPastB) {
      return dateB - dateA; // For past events, most recent first
    }
    
    // If one is today, prioritize it over other upcoming events
    if (isTodayA && !isTodayB) return -1;
    if (!isTodayA && isTodayB) return 1;
    
    // For upcoming events, sort by closest date first
    return dateA - dateB;
  });

  return (
    <>
      <Header/>
      <div className="page-title-container">
    <div className="events-container">
      <h1 className="events-title">Events</h1>

      <div className="events-tabs-wrapper">
        <div className="events-tabs-group" role="group">
          <button
            type=""
            className={`events-tab-button events-tab-left ${
              filter === "all" ? "events-tab-active" : ""
            }`}
            onClick={() => setFilter("all")}
          >
            All Events
          </button>
          <button
            type=""
            className={`events-tab-button ${
              filter === "upcoming" ? "events-tab-active" : ""
            }`}
            onClick={() => setFilter("upcoming")}
          >
            Upcoming
          </button>
          <button
            type=""
            className={`events-tab-button events-tab-right ${
              filter === "past" ? "events-tab-active" : ""
            }`}
            onClick={() => setFilter("past")}
          >
            Past Events
          </button>
        </div>
      </div>

      {loading ? (
        <Loading />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <>
          {sortedEvents.length === 0 ? (
            <div className="events-empty">
              <h3>No events found</h3>
            </div>
          ) : (
            <div className="events-grid">
              {sortedEvents.map((event) => {
                const isPast = isEventPast(event.date);
                const isToday = isEventToday(event.date);
                const eventDate = new Date(event.date);
                
                // Format date to look like "May 15, 2025"
                const formattedDate = eventDate.toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                });
                
                // Format time part
                const formattedTime = eventDate.toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit'
                });

                return (
                  <div
                    key={event._id}
                    className={`events-card ${isPast ? "events-card-past" : ""}`}
                  >
                    <div className="events-status-badge">
                      <span
                        className={`events-status ${
                          isPast ? "past" : isToday ? "happening" : "upcoming"
                        }`}
                      >
                        {isPast ? "Past" : isToday ? "Happening Today" : "Upcoming"}
                      </span>
                    </div>

                    <div className="events-image-wrapper">
                      <img
                        src={event.poster}
                        alt={event.name}
                        className={`events-image ${
                          isPast ? "events-image-past" : ""
                        }`}
                      />
                      {isPast && (
                        <div className="events-overlay">
                          <span>Event Ended</span>
                        </div>
                      )}
                    </div>

                    <div className="events-card-content">
                      <h3>{event.name}</h3>

                      <div className="events-details">
                        <p>
                          <i className="far fa-calendar-alt"></i>
                          {formattedDate}
                        </p>
                        <p>
                          <i className="far fa-clock"></i>
                          {formattedTime}
                        </p>
                        <p>
                          <i className="fas fa-map-marker-alt"></i>
                          {event.location}
                        </p>
                      </div>

                      <div className="events-footer">
                        <span className="events-price">
                          {Number(event.ticketPrice) === 0 ? (
                            <span className="events-free">Free Entry</span>
                          ) : (
                            `Ksh ${event.ticketPrice}`
                          )}
                        </span>

                        {!isPast && (
                          <a
                            href={event.ticketLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="events-ticket-btn"
                          >
                            Get Ticket
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
    </div>
    </>
  );
};

export default EventsScreen;